import { createTheme, Theme } from '@mui/material'

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

type Contrast = 'light' | 'dark'

const primaryColor = {
  50: 'rgb(14, 18, 113)',
  100: 'rgb(14, 18, 113)',
  200: 'rgb(14, 18, 113)',
  300: 'rgb(14, 18, 113)',
  400: 'rgb(14, 18, 113)',
  500: 'rgb(14, 18, 113)',
  600: 'rgb(14, 18, 113)',
  700: 'rgb(14, 18, 113)',
  800: 'rgb(14, 18, 113)',
  900: 'rgb(14, 18, 113)',
  A100: 'rgb(192, 193, 247)',
  A200: 'white',
  A400: 'white',
  A700: 'white',
  contrastDefaultColor: 'light' as Contrast
}

const secondaryColor = {
  50: '#ffd700',
  100: '#ffd700',
  200: '#ffd700',
  300: '#ffd700',
  400: '#ffd700',
  500: '#ffd700',
  600: '#ffd700',
  700: '#ffd700',
  800: '#ffd700',
  900: '#ffd700',
  A100: '#ffd700',
  A200: '#ffd700',
  A400: '#ffd700',
  A700: '#ffd700',
  contrastDefaultColor: 'dark' as Contrast
}

const theme = createTheme({
  typography: {
    fontFamily: 'Futura'
  },
  palette: {
    mode: 'dark',
    primary: primaryColor,
    secondary: secondaryColor,
    info: { main: '#fff' }
  },
  components: {
    MuiTextField: {
      defaultProps: { variant: 'standard' }
    },
    MuiInput: {
      defaultProps: {
        disableUnderline: true
      }
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundImage: 'none'
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          // color: 'white'
        }
      }
    },
    MuiListSubheader: {
      styleOverrides: {
        gutters: {
          background: 'none'
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        outlined: {
          '&.Mui-focused': {
            color: '#fff'
          }
        }
      }
    }
  }
})

export default theme
